import { ExtraScript, ExtraScriptWithUrl } from '@pubstack/common/src/extraScript'
import { MutationToasts, useMutation, useQuery } from '~/api/api-client'

export const EXTRA_SCRIPT_QUERY_KEYS = (siteId: string) => ['adm', 'sites', siteId, 'extra-scripts']
const url = (siteId: string) => `/adm/sites/${siteId}/extra-scripts`
//-------------------------------------------------------------------------
// Queries
//-------------------------------------------------------------------------
export const useExtraScripts = (siteId: string) => {
  return useQuery<ExtraScriptWithUrl[]>({
    url: url(siteId),
    keys: EXTRA_SCRIPT_QUERY_KEYS(siteId),
  })
}
//-------------------------------------------------------------------------
// Mutations
//-------------------------------------------------------------------------
export const useCreateExtraScript = (siteId: string, toasts: MutationToasts = {}) => {
  return useMutation<FormData>({
    method: 'post',
    url: url(siteId),
    collectionKeys: EXTRA_SCRIPT_QUERY_KEYS(siteId),
    ...toasts,
  })
}

export const useUpdateExtraScript = (siteId: string, toasts: MutationToasts = {}) => {
  return useMutation<ExtraScript>({
    method: 'put',
    url: url(siteId),
    collectionKeys: EXTRA_SCRIPT_QUERY_KEYS(siteId),
    ...toasts,
  })
}
